import React, {Fragment} from 'react';
import { render } from 'react-dom';
import { Trans, useTranslation } from 'react-i18next';
import '../i18n';

const ErrorGeneral = () => {
  const { t } = useTranslation();
  return (
      <Fragment>
        <h2>{t("common.error.general.header")}</h2>
        <p>
          <Trans
            i18nKey="common.error.general.content"
            components={[
              <a target="_blank" href="https://www.cmegroup.com/tools-information/webhelp/cmegroup-login/Content/login.html#Clear" />
            ]}
          />
        </p>
        <p>
          <Trans
            i18nKey="common.error.general.support_content"
            components={[<em />]}
          />
        </p>
        <h4>{t("common.txt_phone")}</h4>
        <p>
          {t('common.us_contact')}<br/>
          {t('common.eu_contact')}<br/>
          {t('common.as_contact')}<br/>
        </p>
        <h4>{t("common.txt_email")}</h4>
        <p>
        <a href={`mailto:${t('common.ease_email')}`} target="_parent">{t("common.ease_email")}</a>
        </p>
      </Fragment>
  );
};

render(<ErrorGeneral />, document.getElementById('errorGeneral'));
